import { EFeatureFlags } from "@letshang/constants"
import { useRecoilValue } from "recoil"

import { userState } from "@fuse/recoil/signup"

import { getRemoteConfigValue } from "@firebaseConfig/remoteConfigUtil"

import { DEV } from "./settings"

export const useProcessFeatureFlags = (featureFlag: EFeatureFlags): boolean => {
  // Precedence:
  // 1. User-specific flags from Firestore
  // 2. Remote Config flags
  // 3. Application-level defaults

  // Step 1: Check if user has a value for the flag
  const { feature_flags } = useRecoilValue(userState) as any

  if (feature_flags && feature_flags[featureFlag] !== undefined) {
    const flag = feature_flags[featureFlag]

    // If it's a boolean, return it directly
    if (typeof flag === "boolean") {
      return flag
    }

    // If it's an object with due_date, check if still valid
    if (flag && typeof flag === "object" && flag.due_date) {
      const currentDate = new Date()
      const flagDueDate = new Date(flag.due_date)

      // Return true if the current date is before the due date
      if (currentDate <= flagDueDate) {
        return true
      }
    }
  }

  // Step 2: Check if Remote Config has a value for the flag
  const featureFlagData = getRemoteConfigValue("feature_flags")

  if (featureFlagData) {
    try {
      const parsedData = JSON.parse(featureFlagData)?.[featureFlag]
      if (parsedData !== undefined) {
        const flag = parsedData?.["web"] ?? parsedData?.["default"]
        if (flag !== undefined) {
          return Boolean(flag)
        }
      }
    } catch (error) {
      console.error("Error parsing feature flag data:", error)
    }
  }

  // Step 3: Use application-level defaults
  if (EFeatureFlags.EXPLORE_SECTION === featureFlag) {
    return true
  }

  if (EFeatureFlags.FLEXIBLE_EVENT_CREATION === featureFlag) {
    return DEV || false // Only enabled in dev by default
  }

  // if (
  //   EFeatureFlags.ENABLE_ADD_PLUGIN_TO_EVENT === featureFlag ||
  //   EFeatureFlags.ENABLE_PLUGIN_CREATION === featureFlag
  // ) {
  //   return DEV || false
  // }

  // Default fallback
  return false
}
